import React from 'react';
import styles from './ProfessorDashboard.module.css';

function EmptyState() {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIcon}>
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5 0a4 4 0 11-8-2.954M15 21H3v-1a6 6 0 0112 0v1z" />
        </svg>
      </div>
      <p className={styles.emptyTitle}>No matching students found</p>
      <p className={styles.emptyDescription}>Try adjusting your search filters</p>
    </div>
  );
}

export default EmptyState;